// Candy Super Theme - Premium with animations
const candySuper = {
  id: 'candySuper',
  name: 'Karkki 🍬',
  price: 150,
  main: '#d85a84',
  light: '#ffa4c4',
  dark: '#e91e8c',
  bg: '#fff0f5',
  darkBg: '#2d1a24',
  isSuper: true,
  isDarkTheme: false,
  shape: 'pill',
  surfaces: {
    // Light mode
    lightBg: '#fce4ec',
    lightPaper: '#fff0f5',
    lightContainer: '#fff0f5',
    lightOnSurface: '#2e1a20',
    lightOnSurfaceVariant: '#6d4050',
    lightOutline: '#b06080',
    // Dark mode
    containerLowest: '#2d1a24',
    containerLow: '#1a0e15',
    container: '#2d1a24',
    containerHigh: '#3d2430',
    containerHighest: '#4d2e3c',
    bright: '#5d3848',
    onSurface: '#ffd8e8',
    onSurfaceVariant: '#d4a0b8',
    outline: '#b06080',
    outlineVariant: '#6d4050',
    // Button colors — primary
    primaryContainer: '#ff6b9d',
    onPrimaryContainer: '#3d0020',
    // Button colors — secondary (outlined)
    secondaryContainer: '#4d1a30',
    onSecondaryContainer: '#ffa4c4',
    // Button colors — secondary (filled)
    secondary: '#ffa4c4',
    onSecondary: '#4d1a30',
    secondaryLight: '#e91e8c',
    onSecondaryLight: '#ffffff',
    // Button colors — inverse
    inverseSurface: '#fff0f5',
    onInverseSurface: '#2d1a24',
    inverseSurfaceLight: '#2d1a24',
    onInverseSurfaceLight: '#ffd8e8',
    // Button colors — label/text
    labelColor: '#ffa4c4',
    labelColorLight: '#e91e8c',
    // Status colors
    success: '#4caf50',
    successLight: '#81c784',
    successDark: '#2e7d32',
    warning: '#ffb347',
    warningLight: '#ffd080',
    warningDark: '#e65100',
    error: '#ff6b6b',
    errorLight: '#ff9999',
    errorDark: '#cc0000',
  },
  animations: {
    background: 'float',
    avatar: 'rainbowBorder',
    taskComplete: 'particles',
    taskRainbowBorder: true,
    ambientParticles: false,
    completionGlow: true,
    cardHover: '',
  },
  effects: {
    glowColor: '#ff6b9d50',
    shimmerColors: ['#ff6b9d', '#ffb347', '#87ceeb', '#98fb98'],
  },
  modes: {
    light: {
      background: 'linear-gradient(135deg, #fff0f5 0%, #ffe4ec 50%, #ffd6e7 100%)',
    },
    dark: {
      background: 'linear-gradient(135deg, #2d1a24 0%, #3d2030 50%, #2d1a24 100%)',
      cardBg: 'rgba(255, 107, 157, 0.15)',
    },
  },
};

export default candySuper;
